<template>
  <div>
    <Breadcrumb :title="'Document Manager'"></Breadcrumb>
    <BaseSearchBar :config="searchDocumentGrid" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolbar :config="documentManagerGridToolBarConfig" @buttonClicked="documentManagerGridToolBarClick"></BaseToolbar>
    <BaseGrid :mode="'actionedit'" :excelExport="excelExport" :dropdownOptions="dropdownOptions" :config="documentManagerGridConfig" @change="actionChanged"></BaseGrid>
  </div>
</template>
<script>
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolbar from "@/components/base/BaseToolbar.vue";
import { DocumentManagerGridConfig , DocumentManagerGridToolBarConfig} from "./DocumentManagerConfig.js";
//import { DocumentManagerGridToolBarConfig } from "@/models/DocumentManagerGridToolBar.js";
import toolbarUtility from "@/services/toolbarUtility.js";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import _ from "lodash";
import JSZip from "jszip";
//import JSZipUtils from "jszip-utils";
import  FileSaver  from "file-saver";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import {mapGetters, mapActions, mapState } from 'vuex';
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js"

export default {
  name: "DocumentManager",
  mixins: [toolbarUtility, apiUtil, funcUtil,DocumentManagerMixin],
  computed:{
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
  },
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolbar
  },
  data() {
    return {
      documentManagerGridConfig: DocumentManagerGridConfig,
      documentManagerGridToolBarConfig: DocumentManagerGridToolBarConfig,
      searchDocumentGrid: {
        SearchData: ""
      },
      BaseModelInputControl: BaseModelInputControl,
      DocumentGridMasterData: [],
      dropdownOptions: {},
      excelFormats : ["xlsx","xlsb","xlsm","xls"]
    };
  },
  methods: {  
    ...mapActions("postModule",['UpdateItems','DeleteFile','DeleteAllFiles']),
    UpdateDocumentGridMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.DocumentGridMasterData = filterMasterData;
      } else {
        this.DocumentGridMasterData = $("#DocumentManagerGrid").data().kendoGrid.dataSource.data();
      }
    },
    filterGrid: function() {
      let currentMasterdata = this.DocumentGridMasterData;

      let filteredData = this._filterGrid(this.DocumentGridMasterData,this.searchDocumentGrid.SearchData);

      $("#DocumentManagerGrid").data("kendoGrid").dataSource.data(filteredData);
      this.UpdateDocumentGridMasterData(true, currentMasterdata);
    },
    // getInputControls() {
    //   let self = this;
    //   let response = self.getLocalInputControls(
    //     self.BaseModelInputControl.list
    //   );
    //   this.dropdownOptions["DocumentType"] = response["DocumentType"];
    // },
  },

  mounted() {
    let grid = $("#DocumentManagerGrid").data("kendoGrid");
    grid.bind("dataBound", this.UpdateDocumentGridMasterData);
    grid.dataSource.fetch();

    //Get All Input Controls ( Document Type from here)
    this.getInputControls("AdminDropZone");

    this._loadGridSettings("DocumentManagerGrid");
  }
};
</script>